import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateUserRoles = api(async function updateUserRoles({ id, roles }) {
    return mutate(
        gql`
            mutation UpdateUserRoles($id: ID!, $roles: [String]) {
                updateUserRoles(id: $id, roles: $roles)
            }
        `,
        {
            id,
            roles,
        },
        { returns: "updateUserRoles" }
    )
})
